import React from 'react';
import { Container, Row } from 'reactstrap';
import NavBar from '../../components/NavBar';

const ErrorPage = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div>
     <Container fluid>
          <Row>
            <NavBar />
          </Row>
    <div className="container d-flex justify-content-center align-items-center min-vh-100 p-3">
      <div className="card shadow-sm" style={{ maxWidth: '500px', width: '100%' }}>
        <div className="card-body text-center">
          <img
            alt="Illustration of a female doctor in blue scrubs standing beside a hospital bed with a patient lying down covered with a white blanket"
            className="img-fluid"
            src="https://storage.googleapis.com/a1aa/image/7dc0da43-42c4-4406-c197-4cffab044c42.jpg"
            style={{ maxWidth: '320px', height: '180px' }}
          />
          <h2 className="mt-4 text-dark font-weight-semibold">
            Oops! It seems like something went wrong.
          </h2>
          <p className="mt-3 text-muted">
            We couldn't find the page you're looking for.
            <br />
            We'll work on improving this.
          </p>
          <button
            className="btn btn-info mt-4"
            onClick={handleRefresh}
          >
            Refresh Page
          </button>
        </div>
      </div>
    </div>
    </Container>
    </div>
  );
};

export default ErrorPage;
